import classnames from 'classnames';
import { CSSProperties } from 'react';
import { ViewportStyles } from '../../../../global/types/viewport.type';
import s from '../page.module.scss';

export type LayoutsPageContentProps = {
  children?: React.ReactNode;
  className?: string | Array<string>;
  noPadding?: boolean;
  fullWidth?: boolean;
  center?: boolean;
  transparent?: boolean;
  style?: ViewportStyles; // contextStyle type
};
const getClassNames = (names: Array<string>, styles: CSSProperties) =>
  names.map(name => styles[name]);

const PageContent = ({
  className = '',
  center = false,
  children,
  style = { mobile: {} },
  noPadding = false,
  fullWidth = false,
  transparent = false,
}: LayoutsPageContentProps) => (
  <div
    className={classnames(
      s.content,
      transparent && s['transparent'],
      fullWidth && s['full-width'],
      noPadding && s['no-padding'],
      center && s['center'],
      Array.isArray(className) ? getClassNames(className, s) : className,
    )}
    style={context.handleStyle(style)}
  >
    {children}
  </div>
);

export default PageContent;
